import React,{useRef,useContext, useState} from "react";

export const RoleContext = React.createContext();

export const RoleProvider = (props)=>{
    const roleRef = useRef('');
    const [roleState,setRoleState] = useState('');
    
    const RoleRef = (newRoleState) => {
        roleRef.current = newRoleState;
    };

    const value = {
        roleState,
        setRoleState,
        roleRet:roleRef,
        RoleRef
    };

    return <RoleContext.Provider value={roleRef}>{props.children}</RoleContext.Provider>
}

export default RoleContext;